var SupportGPassPresenterPresentation, SupportGetawaysBookingPresenterPresentation, SupportGetawaysMarketRatePresenterPresentation, SupportGetawaysTonightPresenterPresentation, SupportGetawaysVoucherPresenterPresentation, SupportGoodsShippingPresenterPresentation, SupportGoodsVoucherPresenterPresentation, SupportLivePresenterPresentation, SupportLiveVoucherPresenterPresentation, SupportLocalPresenterPresentation, SupportNowPresenterPresentation, SupportPresenterFactoryPresentation;

SupportGetawaysBookingPresenterPresentation = require('./getaways_booking_presenter');

SupportGetawaysVoucherPresenterPresentation = require('./getaways_voucher_presenter');

SupportGoodsShippingPresenterPresentation = require('./goods_shipping_presenter');

SupportGoodsVoucherPresenterPresentation = require('./goods_voucher_presenter');

SupportGPassPresenterPresentation = require('./gpass_presenter');

SupportLivePresenterPresentation = require('./live_presenter');

SupportLiveVoucherPresenterPresentation = require('./live_voucher_presenter');

SupportLocalPresenterPresentation = require('./local_presenter');

SupportNowPresenterPresentation = require('./now_presenter');

SupportGetawaysMarketRatePresenterPresentation = require('./getaways_market_rate_presenter');

SupportGetawaysTonightPresenterPresentation = require('./getaways_tonight_presenter');

SupportPresenterFactoryPresentation = (function() {
  function SupportPresenterFactoryPresentation() {}

  SupportPresenterFactoryPresentation.prototype.makePresenter = function(order) {
    var deal_type, ref;
    if (order != null) {
      deal_type = order.DEAL_TYPE;
      if (deal_type != null) {
        switch (deal_type.toLowerCase()) {
          case 'goods_shipping':
            return new SupportGoodsShippingPresenterPresentation(order);
          case 'goods_voucher':
            return new SupportGoodsVoucherPresenterPresentation(order);
          case 'getaways_booking':
            return new SupportGetawaysBookingPresenterPresentation(order);
          case 'getaways_voucher':
            return new SupportGetawaysVoucherPresenterPresentation(order);
          case 'live_voucher':
            return new SupportLiveVoucherPresenterPresentation(order);
          case 'live':
            if ((ref = order.dealOption) != null ? ref.isTicketedDealOption : void 0) {
              return new SupportGPassPresenterPresentation(order);
            } else {
              return new SupportLivePresenterPresentation(order);
            }
            break;
          case 'local':
            return new SupportLocalPresenterPresentation(order);
          case 'now':
            return new SupportNowPresenterPresentation(order);
          case 'getaways_market_rate':
            return new SupportGetawaysMarketRatePresenterPresentation(order);
          case 'getaways_tonight':
            return new SupportGetawaysTonightPresenterPresentation(order);
          default:
            return new SupportLocalPresenterPresentation(order);
        }
      }
    }
  };

  return SupportPresenterFactoryPresentation;

})();

module.exports = SupportPresenterFactoryPresentation;

//# sourceMappingURL=data:application/json;base64,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
